import { Grid } from "@material-ui/core";
import * as React from "react";
import { connect } from "react-redux";

import { Dispatch, StoreState } from "../../store";
import { CustomerGroupFilterState } from "../../types/index";
import Autocomplete from "../Autocomplete";
import { FilterGroup } from "./constants";
import FilterContainer from "./FilterContainer";

function mapStateToProps({ nextBestActivities }: StoreState) {
  return {
    nextBestActivities,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    fetchNextBestActivities: () =>
      dispatch.nextBestActivities.fetchNextBestActivities(null),
  };
}

interface Props {
  nextBestActivities: Array<{ name: string; uuid: string }>;
  nextBestActivityFilter: string[];
  enabled: boolean;
  changeCustomerGroupFilter: (
    payload: Partial<CustomerGroupFilterState>
  ) => void;
  handleEnabledChange: (filterGroup: FilterGroup, checked: boolean) => void;
  fetchNextBestActivities: () => void;
}

class NextBestActivityFilter extends React.Component<Props> {
  public componentDidMount() {
    this.props.fetchNextBestActivities();
  }

  public render(): JSX.Element {
    return (
      <FilterContainer
        enabled={this.props.enabled}
        title="Beratungsfokus / NBA"
        onEnabledChange={(enabled) => {
          this.props.handleEnabledChange(FilterGroup.nextBestActivity, enabled);
        }}
      >
        {(disabled?: boolean) => (
          <Grid container={true} spacing={2}>
            <Grid item={true} xs={12}>
              <Autocomplete
                disabled={disabled}
                options={this.props.nextBestActivities.map((nba) => ({
                  label: nba.name,
                  value: nba.name,
                }))}
                value={this.props.nextBestActivityFilter.map((label) => ({
                  label,
                  value: label,
                }))}
                onChange={this.handleChangeNextBestActivity}
                label="Maßnahme auswählen"
                placeholder="Bitte auswählen..."
              />
            </Grid>
          </Grid>
        )}
      </FilterContainer>
    );
  }
  private handleChangeNextBestActivity = (
    value: Array<{ label: string; value: string }>
  ) => {
    this.props.changeCustomerGroupFilter({
      nextBestActivityFilter: value.map((value) => value.value),
    });
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NextBestActivityFilter);



// WEBPACK FOOTER //
// ./src/components/Filters/NextBestActivityFilter.tsx